import React, { useEffect, useState } from 'react';

import { useDebounce } from '../../hooks/use-debounce.hook';
import { PasswordInputComponent } from '../components/password-input.component';
let isOnChangeTriggered = false;
export function PasswordInputContainer ({ icon, type, name, label, value, onValueChange, placeholder, isDisabled, isRequired }: any) {
  const [
    inputValue,
    setInputValue
  ] = useState(value);
  const debouncedInputValue = useDebounce(
    inputValue,
    500
  );

  useEffect(
    () => {
      if (debouncedInputValue && inputValue && debouncedInputValue === inputValue && isOnChangeTriggered) {
        isOnChangeTriggered = false;
        onValueChange({
          persist: () => {},
          target: {
            type: 'change',
            name,
            value: debouncedInputValue,
          },
        });
      }
    },
    [debouncedInputValue]
  )
  useEffect(
    () => {
      setInputValue(value)
    },
    [value]
  )
  return (<PasswordInputComponent
      icon={icon}
      isDisabled={isDisabled}
      isRequired={isRequired}
      label={label}
      name={name}
      onValueChange={
        (event: any) => {
          isOnChangeTriggered = true;
          setInputValue(event.target.value)
        }
      }
      placeholder={placeholder}
      type={type}
      value={inputValue}
          />)
}
